/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Font_Color_AriaInputs */

const en_video_export_font_color_aria = /** @type {(inputs: Video_Export_Font_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Font Color`)
};

const fr_video_export_font_color_aria = /** @type {(inputs: Video_Export_Font_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur de police`)
};

const de_video_export_font_color_aria = /** @type {(inputs: Video_Export_Font_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftfarbe`)
};

const it_video_export_font_color_aria = /** @type {(inputs: Video_Export_Font_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore del carattere`)
};

const ru_video_export_font_color_aria = /** @type {(inputs: Video_Export_Font_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цвет шрифта`)
};

const es_video_export_font_color_aria = /** @type {(inputs: Video_Export_Font_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color de fuente`)
};

const zh_cn2_video_export_font_color_aria = /** @type {(inputs: Video_Export_Font_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字体颜色`)
};

const ja_video_export_font_color_aria = /** @type {(inputs: Video_Export_Font_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォント色`)
};

const hi_video_export_font_color_aria = /** @type {(inputs: Video_Export_Font_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉन्ट रंग`)
};

const pt_pt2_video_export_font_color_aria = /** @type {(inputs: Video_Export_Font_Color_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor da fonte`)
};

/**
* | output |
* | --- |
* | "Font Color" |
*
* @param {Video_Export_Font_Color_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_font_color_aria = /** @type {((inputs?: Video_Export_Font_Color_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Font_Color_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_font_color_aria(inputs)
	if (locale === "de") return de_video_export_font_color_aria(inputs)
	if (locale === "it") return it_video_export_font_color_aria(inputs)
	if (locale === "ru") return ru_video_export_font_color_aria(inputs)
	if (locale === "es") return es_video_export_font_color_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_font_color_aria(inputs)
	if (locale === "ja") return ja_video_export_font_color_aria(inputs)
	if (locale === "hi") return hi_video_export_font_color_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_font_color_aria(inputs)
	return en_video_export_font_color_aria(inputs)
});